import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import { followUps } from '../lib/salesData';

const KINDS: { k: 'quote' | 'lead' | 'reorder'; label: string; ico: string }[] = [
  { k: 'quote', label: 'Open Quotes', ico: '◆' }, { k: 'lead', label: 'Warm Leads', ico: '✦' }, { k: 'reorder', label: 'Reorder Opportunities', ico: '↻' },
];

export default function FollowUps() {
  const { demo } = useAuth();
  const { data, loading } = useAccounts(demo);
  const nav = useNavigate();
  const items = useMemo(() => followUps(data?.accounts ?? []), [data]);
  const [done, setDone] = useState<Record<string, boolean>>({});

  if (loading) return <div className="loading"><div className="spinner" /> Loading follow-ups…</div>;
  const key = (i: number) => `f${i}`;
  const openCount = items.filter((_, i) => !done[key(i)]).length;

  return (
    <>
      <div className="page-head">
        <div><div className="page-title">Follow-Up System</div><div className="page-sub">Never forget to follow up on open quotes, warm leads, or reorder opportunities.</div></div>
        <span className="live-flag">{openCount} open</span>
      </div>

      <div className="grid cols-3">
        {KINDS.map(({ k, label, ico }) => {
          const group = items.map((it, i) => ({ it, i })).filter(({ it }) => it.kind === k);
          return (
            <div className="card" key={k}>
              <div className="card-header"><div><h3>{ico} {label}</h3><p>{group.filter(({ i }) => !done[key(i)]).length} to action</p></div></div>
              <div className="card-body"><div className="mini-list">
                {group.length === 0 && <div className="sub">Nothing here.</div>}
                {group.map(({ it, i }) => (
                  <div className={`reminder-row${done[key(i)] ? ' done' : ''}`} key={i}>
                    <span className="rm-check" onClick={() => setDone((d) => ({ ...d, [key(i)]: !d[key(i)] }))}>{done[key(i)] ? '✓' : ''}</span>
                    <div className="mr-main" onClick={() => nav(`/client?id=${encodeURIComponent(it.clientId)}`)} style={{ cursor: 'pointer' }}>
                      <strong>{it.label}</strong>
                      <div className="mr-sub">{it.clientName} · {it.detail}</div>
                    </div>
                    <span className="due-chip">{it.due}</span>
                  </div>
                ))}
              </div></div>
            </div>
          );
        })}
      </div>
    </>
  );
}
